import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';
import { loadZohoForm } from 'src/components/zoho/zohoForm'
import FirebaseApp from 'src/config/firebase.config';

const AddLeadDetails = (props) => {
  const navigate = useNavigate()
  const FirebaseDB = FirebaseApp.firestore()
  const { formId } = useParams();
  const url = 'https://forms.zohopublic.in/vickyagravat/form/SoftwareEvaluation/formperma/MgmBr4_nF6qCMLyL8myOUVRO79hjPJccV-UiiuAA6H0?zf_rszfm=1'
  const uid = '5qWXH8k124XWX2qBrLrvSq0FZe43'

  useEffect(() => {
    loadZohoForm(url, uid, { formId: formId})
  }, [])

  return (
    <div id="zoho-form"></div>
    // <iframe title="zoho-form" src="https://forms.zohopublic.in/vickyagravat/form/SoftwareEvaluation/formperma/MgmBr4_nF6qCMLyL8myOUVRO79hjPJccV-UiiuAA6H0?fid=uIKdR9Dn0kuIE9HE5eXe&event=event1&uid=kqqqoitsZpVkkzo6ffWnc8hZ1el1&name=Vicky&email=vicky.agrava@gmail.com&long=Less%20than%20a%20year&try=No" width="100%" height="100vh" />
  )
}

export default AddLeadDetails;
